import React from 'react';
import { TFunction } from 'i18next';
import { BaseItem, CellProps, Column } from '@lib/components/Table/types';
import ToggleCell from '@lib/components/Table/cells/ToggleCell';
import ToggleHeaderCell from '@lib/components/Table/cells/ToggleHeaderCell';
import { UseToggleColumnResult } from '@lib/hooks/useTableItemsToggleColumn';

export default function buildVisibleViaQrColumn<T extends BaseItem>(
  result: UseToggleColumnResult<T>,
  t: TFunction,
): Column<T> {
  function Cell({ item }: CellProps<T>) {
    return (
      <ToggleCell
        id={item.id}
        checked={result.getRowToggleChecked(item)}
        disabled={result.getRowToggleDisabled(item)}
        onChange={(next) => result.onRowToggleChange(item, next)}
        labelChecked={t('visible')}
        labelUnchecked={t('visible')}
        labelDisabled={t('unavailable')}
        tooltipBodyChecked={t('visible-via-qr-on')}
        tooltipBodyUnchecked={t('visible-via-qr-off')}
        tooltipBodyDisabled={t('visible-via-qr-disabled')}
      />
    );
  }

  return {
    id: 'visible-via-qr',
    isCustomHeader: true,
    isSingleLineHeader: true,
    noWrap: true,
    minWidth: 200,
    Header: (
      <ToggleHeaderCell
        id="table-head-visible-via-qr"
        checked={result.headerToggleChecked}
        disabled={result.headerToggleDisabled}
        onChange={result.onHeaderToggleChange}
        label={t('visible-via-qr')}
        tooltipBody={t('visible-via-qr-info')}
      />
    ),
    Cell,
  };
}
